import React, { useState, useEffect, useRef } from 'react';
import Nav from '../components/Nav/Nav';
import {
  ArrowLeftOutlined,
  PlusOutlined,
  LoadingOutlined,
  DeleteOutlined,
  CloseOutlined
} from '@ant-design/icons';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import imageCompression from 'browser-image-compression';
import '../App.css';

function NewProduct() {
  const {
    postProduct,
    isLoading,
    productM,
    listCategories,
    languages,
    getCategories,
    getProducts,
    listProducts,
    t,
    tOption,
    translated,
    translated2,
    t2,
    translatedOpt,
    getRestaurant,
    currentRestaurant,
    uploadPhotoFile,
    uploadDigitalProductFile
  } = useAuth();

  const navigate = useNavigate();
  const { id } = useParams();

  const [name, setName] = useState('');
  const [price, setPrice] = useState('');
  const [description, setDescription] = useState('');
  const [allergens, setAllergens] = useState('');
  const [category, setCategory] = useState('');
  const [photos, setPhotos] = useState([]);
  const [previews, setPreviews] = useState([]);
  const [status, setStatus] = useState('visible');
  const [label, setLabel] = useState('');
  const [checkboxState, setCheckboxState] = useState({});
  const [checkboxState2, setCheckboxState2] = useState({});
  const [checkboxStateOpt, setCheckboxStateOpt] = useState({});
  const [langSelected, setLangSelected] = useState([]);
  const [options, setOptions] = useState([]);
  const [optionMode, setOptionMode] = useState('');
  const [quantity, setQuantity] = useState(0);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [digitalFileName, setDigitalFileName] = useState('');
  const digitalFileInputRef = useRef(null);
  const [digitalFile, setDigitalFile] = useState(null);

  const MAX_OPTIONS = 8;
  const MAX_FILE_SIZE = 50 * 1024 * 1024;

  const isDigitalProduct = currentRestaurant?.productType === 'digital';

  const MyCategories = listCategories?.filter(
    (categorie) => categorie.restaurant === id
  );

  const MyProducts = listProducts?.filter(
    (product) => product.category === category
  );

  useEffect(() => {
    getProducts(id);
    getCategories(id);
    getRestaurant(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    if (langSelected.length === languages?.length && options.length > 0) {
      tOption(options, langSelected);
      setLangSelected([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [langSelected]);

  useEffect(() => {
    if (!productM) return;

    setName('');
    setDescription('');
    setAllergens('');
    setPrice('');
    setPhotos([]);
    setPreviews([]);
    setCheckboxState({});
    setCheckboxState2({});
    setCheckboxStateOpt({});
    setLangSelected([]);
    setOptions([]);
    setOptionMode('');
    setLabel('');
    setCategory('');
    setQuantity(0);
    setDigitalFile(null);
    setDigitalFileName('');

    if (digitalFileInputRef.current) {
      digitalFileInputRef.current.value = '';
    }
  }, [productM]);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (isLoading || isSubmitting) return;

    if (isDigitalProduct && !digitalFile) {
      alert('Veuillez ajouter un fichier ZIP pour ce produit digital.');
      return;
    }

    setIsSubmitting(true);

    try {
      let finalDigitalFileName = '';
      let finalDigitalFilePath = '';

      const picturesUrls = await Promise.all(photos.map(uploadPhotoFile));

      if (isDigitalProduct && digitalFile) {
        const uploadedDigitalFile = await uploadDigitalProductFile(digitalFile, id);
        if (!uploadedDigitalFile) {
          alert("Impossible d'uploader le fichier digital.");
          return;
        }

        finalDigitalFileName = uploadedDigitalFile.name;
        finalDigitalFilePath = uploadedDigitalFile.path;
      }

      await postProduct(
        name,
        price,
        description,
        category,
        picturesUrls[0] || '',
        status,
        (MyProducts?.length || 0) + 1,
        id,
        translated,
        !isDigitalProduct
          ? options.length > 0
            ? translatedOpt.length > 0
              ? translatedOpt
              : options
            : []
          : [],
        !isDigitalProduct ? translated2 : {},
        !isDigitalProduct ? allergens : '',
        !isDigitalProduct ? label : '',
        isDigitalProduct ? 1000000 : Number(quantity || 0),
        isDigitalProduct ? finalDigitalFileName : '',
        !!isDigitalProduct,
        isDigitalProduct ? finalDigitalFilePath : '',
        picturesUrls
      );

      getProducts(id);
      getCategories(id);
    } catch (error) {
      console.log(error);
      alert('Erreur pendant la création du produit.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCheckboxChange = (code) => {
    setCheckboxState((prevState) => ({
      ...prevState,
      [code]: !prevState[code],
    }));
    t(description, code);
  };

  const handleCheckboxChange2 = (code) => {
    setCheckboxState2((prevState) => ({
      ...prevState,
      [code]: !prevState[code],
    }));
    t2(allergens, code);
  };

  const handleCheckboxChangeOpt = (code) => {
    setCheckboxStateOpt((prevState) => ({
      ...prevState,
      [code]: !prevState[code],
    }));
    setLangSelected((prev) => [...prev, code]);
  };

  const handleAddPhoto = (event) => {
    const imageFile = event.target.files[0];
    if (!imageFile) return;
    event.target.value = '';

    if (photos.length >= 5) return;

    const compressionOptions = { maxSizeMB: 0.3, maxWidthOrHeight: 700, useWebWorker: true };

    imageCompression(imageFile, compressionOptions)
      .then((compressedFile) => {
        setPhotos((prev) => [...prev, compressedFile]);
      })
      .catch((error) => console.log(error.message));

    const reader = new FileReader();
    reader.onloadend = () => setPreviews((prev) => [...prev, reader.result]);
    reader.readAsDataURL(imageFile);
  };

  const handleRemovePhoto = (index) => {
    setPhotos((prev) => prev.filter((_, i) => i !== index));
    setPreviews((prev) => prev.filter((_, i) => i !== index));
  };

  const handleDigitalFileChange = (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    const fileName = file.name.toLowerCase();

    const isZip =
      file.type === 'application/zip' ||
      file.type === 'application/x-zip-compressed' ||
      fileName.endsWith('.zip');

    if (!isZip) {
      alert('Seuls les fichiers .zip sont acceptés pour les produits digitaux.');
      event.target.value = '';
      return;
    }

    if (file.size > MAX_FILE_SIZE) {
      alert('Le fichier est trop volumineux. Taille maximale : 50 MB.');
      event.target.value = '';
      return;
    }

    setDigitalFile(file);
    setDigitalFileName(file.name);
  };

  const createOptionId = () =>
    `opt_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;

  const handleAddOption = (type) => {
    if (!type || isDigitalProduct) return;
    if (options.length >= MAX_OPTIONS) return;
    if (optionMode && optionMode !== type) return;

    setOptionMode(type);
    setOptions((prev) => [
      ...prev,
      {
        id: createOptionId(),
        name: '',
        price: '',
        type,
      },
    ]);
    setCheckboxStateOpt({});
  };

  const removeOption = (indexToRemove) => {
    const nextOptions = options.filter((_, index) => index !== indexToRemove);
    setOptions(nextOptions);

    if (nextOptions.length === 0) {
      setOptionMode('');
    }
  };

  const handleOptionChange = (index, field, value) => {
    const updatedOptions = [...options];
    updatedOptions[index][field] = value;
    setOptions(updatedOptions);
  };

  const canAddOptionType = !optionMode || optionMode === '1';
  const canAddSupplementType = !optionMode || optionMode === '2';
  const reachedMaxOptions = options.length >= MAX_OPTIONS;
  const submitLoading = isLoading || isSubmitting;

  return (
    <div>
      <Nav />

      <form onSubmit={handleSubmit} className="wrapper-container">
        <div className="wrapper-content">
          <div className="title-wrapper">
            <div className="title-back">
              <ArrowLeftOutlined onClick={() => navigate(-1)} className="back" />
              <p>Nouveau produit</p>
            </div>
          </div>

          <div className="wrapper-form">
            <div className="input-container">
              <label htmlFor="name">Nom du produit</label>
              <input
                type="text"
                id="name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </div>

            <div className="input-container">
              <label htmlFor="price">Prix</label>
              <input
                type="number"
                min="0"
                step="0.01"
                id="price"
                value={price}
                onChange={(e) => setPrice(e.target.value)}
                required
                placeholder="€"
              />
            </div>
            {!isDigitalProduct && (
            <div className="input-container">
              <label htmlFor="quantity">Stock disponible</label>
              <input
                type="number"
                id="quantity"
                min="0"
                step="1"
                value={quantity}
                onChange={(e) => setQuantity(Number(e.target.value))}
                required
              />
            </div>
)}
            <div className="input-container">
              <label htmlFor="category">Catégorie</label>
              <select
                id="category"
                value={category}
                onChange={(e) => setCategory(e.target.value)}
                required
              >
                <option value="">Choisir une catégorie</option>
                {MyCategories?.map((categorie) => (
                  <option key={categorie.id} value={categorie.id}>
                    {categorie.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="input-container">
              <label htmlFor="description">Description</label>
              <input
                type="text"
                id="description"
                value={description}
                onChange={(e) => {
                  setDescription(e.target.value);
                  if (e.target.value === '..') setDescription(name);
                }}
              />
            </div>

            <div className="input-container" style={{ height: 'auto' }}>
              <label>Photos</label>
              <div className="photo-grid">
                {previews.map((preview, i) => (
                  <div key={i} className="photo-grid-item">
                    <img src={preview} alt="" className="photo-grid-thumb" />
                    <button type="button" className="photo-grid-remove" onClick={() => handleRemovePhoto(i)}>
                      <CloseOutlined />
                    </button>
                  </div>
                ))}
                {photos.length < 5 && (
                  <div className="photo-grid-item photo-grid-add">
                    <PlusOutlined />
                    <span className="photo-grid-hint">800×800 px</span>
                    <input className="inputfile" type="file" accept="image/*" onChange={handleAddPhoto} />
                  </div>
                )}
              </div>
            </div>

            {isDigitalProduct && (
  <div className="input-container" style={{ height: 'auto' }}>
    <label htmlFor="digitalFile">Fichier digital</label>

    <div className="digital-file-upload">
      <label htmlFor="digitalFile" className="digital-file-label">
        Charger le fichier ZIP
      </label>

      <input
        ref={digitalFileInputRef}
        className="digital-file-input"
        type="file"
        id="digitalFile"
        accept=".zip,application/zip,application/x-zip-compressed"
        onChange={handleDigitalFileChange}
        required
      />

<p className="digital-file-help">
  {digitalFileName
    ? `${digitalFileName}`
    : 'Fichier .zip uniquement · 50 MB max'}
</p>
    </div>
  </div>
)}

            {!isDigitalProduct && (
              <div className="input-container">
                <label htmlFor="allergen">Allèrgenes</label>
                <input
                  type="text"
                  id="allergen"
                  value={allergens}
                  placeholder="Exemple : Noix - Oeuf - Lait"
                  onChange={(e) => setAllergens(e.target.value)}
                />
              </div>
            )}

            {!isDigitalProduct && (
              <div className="input-container">
                <label htmlFor="label">Label</label>
                <select
                  id="label"
                  value={label}
                  onChange={(e) => setLabel(e.target.value)}
                >
                  <option value="">Choisir un label</option>
                  <option value="vegetarien">Végétarien</option>
                  <option value="halal">Halal</option>
                </select>
              </div>
            )}

            <div className="input-container">
              <label htmlFor="status">Status</label>
              <select
                id="status"
                value={status}
                onChange={(e) => setStatus(e.target.value)}
                required
              >
                <option value="visible">Visible</option>
                <option value="hidden">Masqué</option>
              </select>
            </div>

            {description && (
              <div className="input-container" style={{ display: 'none' }}>
                <label htmlFor="checkbox">Traduction</label>

                <div className="checkbox-container">
                  {languages.map((language) => (
                    <label key={language.code}>
                      <input
                        type="checkbox"
                        checked={checkboxState[language.code] || false}
                        onChange={() => handleCheckboxChange(language.code)}
                      />
                      {language.name}
                    </label>
                  ))}
                  <div>{Object.keys(translated)?.length}</div>
                </div>
              </div>
            )}

            {!isDigitalProduct && allergens && (
              <div className="input-container" style={{ display: 'none' }}>
                <label htmlFor="checkbox">Traduction</label>

                <div className="checkbox-container">
                  {languages.map((language) => (
                    <label key={language.code}>
                      <input
                        type="checkbox"
                        checked={checkboxState2[language.code] || false}
                        onChange={() => handleCheckboxChange2(language.code)}
                      />
                      {language.name}
                    </label>
                  ))}
                </div>
              </div>
            )}

            {!isDigitalProduct && (
              <>
                <div className="validation-container extra-container">
                  <label htmlFor="label">Extra</label>

                  {canAddOptionType && !reachedMaxOptions && (
                    <button
                      style={{ marginLeft: 10 }}
                      className="button save more-option"
                      type="button"
                      onClick={() => handleAddOption('1')}
                    >
                      Ajouter une option
                    </button>
                  )}

                  {canAddSupplementType && !reachedMaxOptions && (
                    <button
                      style={{ marginLeft: 10 }}
                      className="button save more-option"
                      type="button"
                      onClick={() => handleAddOption('2')}
                    >
                      Ajouter un supplément
                    </button>
                  )}
                </div>

                {options.map((option, index) => (
                  <div key={option.id || index} className="option-wrapper">
                    <div className="input-container">
                      <label htmlFor={`option-name-${index}`}>
                        {option.type === '2'
                          ? `supplément ${index + 1}`
                          : `option ${index + 1}`}
                      </label>

                      <div className="option-container">
                        <DeleteOutlined onClick={() => removeOption(index)} />

                        <input
                          type="text"
                          className="input-option-name"
                          id={`option-name-${index}`}
                          value={option.name}
                          onChange={(e) => {
                            handleOptionChange(index, 'name', e.target.value);
                            if (e.target.value === '..') {
                              handleOptionChange(index, 'name', name);
                            }
                          }}
                          placeholder="Nom"
                        />

                        <input
                          type="number"
                          min="0"
                          step="0.01"
                          className="input-option-price"
                          id={`option-price-${index}`}
                          value={option.price}
                          onChange={(e) => handleOptionChange(index, 'price', e.target.value)}
                          placeholder="Prix"
                        />
                      </div>
                    </div>
                  </div>
                ))}

                {options.length > 0 && (
                  <div className="input-container" style={{ display: 'none' }}>
                    <label htmlFor="checkbox">Traduction</label>

                    <div className="checkbox-container">
                      {languages.map((language) => (
                        <label key={language.code}>
                          <input
                            type="checkbox"
                            checked={checkboxStateOpt[language.code] || false}
                            onChange={() => handleCheckboxChangeOpt(language.code)}
                          />
                          {language.name}
                        </label>
                      ))}
                      <div>{langSelected?.length}</div>
                      <div>{translatedOpt?.length}</div>
                    </div>
                  </div>
                )}
              </>
            )}

            <div className="validation-container">
              <button
                className="button save"
                type="submit"
                disabled={submitLoading}
              >
                {submitLoading ? <LoadingOutlined spin /> : 'Enregistrer'}
              </button>

              {productM && <div className="delete info">{productM}</div>}
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}

export default NewProduct;